import type { FunctionComponent } from 'react';
import { useCallback } from 'react';

import { useCoreDispatch } from '../../store/CoreStore';
import { useGameStateSlice } from '../../store/slices/game/selectors';
import { gameStateActions } from '../../store/slices/game/slice';
import { useSettingsSlice } from '../../store/slices/settings/selectors';

import { Stream } from './Stream';
import type { StreamProps } from './types';

export interface StreamConnectedProps extends Omit<StreamProps, 'classic' | 'poster' | 'setPoster'> {}

export const StreamConnected: FunctionComponent<StreamConnectedProps> = ({ ...rest }) => {
  const dispatch = useCoreDispatch();
  const classic = useSettingsSlice.getIsInClassicView();
  const poster = useGameStateSlice.getVideoPoster();

  const setPoster = useCallback(
    (newPoster: string) => {
      dispatch(gameStateActions.setVideoPoster(newPoster));
    },
    [dispatch]
  );

  return <Stream classic={classic} poster={poster} setPoster={setPoster} {...rest} />;
};
